import styled from "styled-components";
import { Q } from "@/lib/styles";

export const Container = styled.figure`
  margin-bottom: 2.5rem;
`;

export const Body = styled(Q)`
  font-family: ${({ theme }) => theme.fontFamilies.primary};
  font-style: normal;
`;

export const Caption = styled.figcaption`
  margin-top: 24px;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.6;
  color: rgba(50, 50, 50, 0.64);
`;
